import { render, staticRenderFns } from "./ChassisFilters.vue?vue&type=template&id=39e72339&scoped=true&"
import script from "./ChassisFilters.vue?vue&type=script&lang=ts&"
export * from "./ChassisFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e72339",
  null
  
)

export default component.exports